import { urlsConfig } from 'src/configs';
import { axios } from '../utils';
import { AxiosPromise } from 'axios';

export const getUserManualRaw = (): AxiosPromise<any> => {
  return axios.get(urlsConfig.helpAndSupport.docRaw, {
    responseType: 'arraybuffer',
  });
};

export const getUserManualRawMil = (): AxiosPromise<any> => {
  return axios.get(urlsConfig.helpAndSupport.docRawMil, {
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/pdf',
    },
  });
};
